import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import Validation from "@irati/utils/validation"

export const formFieldValidation = (formatMessage: FormatMessage) => {
  const errorMessage = formatMessage({id: "flexiRewards.merchandise.checkout.form.validationMessage"})
  const requiredMessage = formatMessage({id: "flexiRewards.merchandise.checkout.form.required"})

  return Validation.string(requiredMessage).matches(/[a-z]/gi, errorMessage)
}
